import Vue from 'vue'
import Vuetify from 'vuetify/lib'
import 'vuetify/src/stylus/app.styl'
import '@/stylus/main.styl'

// vuetify-loader will automatically import all Vuetify components as you use them
// https://github.com/vuetifyjs/vuetify-loader
Vue.use(Vuetify, {
  options: {
    customProperties: true
  },
  theme: {
    primary: '#000000', // '#d2b48c', // #FAF3EB
    secondary: '#f6f6f6',
    accent: '#FAF3EB',
  },
  iconfont: 'fa',
  icons: {
    complete: 'fas fa-check',
    edit: 'fas fa-edit',
    next: 'fas fa-angle-right',
    prev: 'fas fa-angle-left',
    clear: 'fas fa-times',
    dropdown: 'fas fa-angle-down',
    subgroup: 'fas fa-angle-down',
    expand: 'fas fa-angle-down',
    delete: 'fas fa-times',
  }
})
